import React, { useState, useCallback } from 'react';
import { View } from 'react-native';

import { OETextInput } from '../../atoms/oe-text-input/oe-text-input';
import FormFooter from '../../molecules/form-footer/form-footer';
import { flex, mr, mb, height, color, borderColor } from '../../style-utils';

export interface ContactUsFormLabels {
  nameLabel: string;
  emailLabel: string;
  messageInputPlaceholder: string;
  buttonCancel: string;
  buttonSubmit: string;
}

export interface ContactUsFormProps {
  onSubmit: (message: string) => void;
  onCancel: () => void;
  email: string;
  name: string;
  labels: ContactUsFormLabels;
  isLoading?: boolean;
  error?: string;
  buttonTextColorConfirm?: string;
  buttonTextColorCancel?: string;
}

export const ContactUsForm: React.FC<ContactUsFormProps> = ({
  labels,
  isLoading,
  error,
  onSubmit,
  onCancel,
  email,
  name,
  buttonTextColorConfirm,
  buttonTextColorCancel,
}) => {
  const [formData, setFormData] = useState({
    message: '',
  });
  const { message } = formData;

  const handleFieldChange = (value: string, name?: string) => {
    if (name) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = useCallback(() => {
    onSubmit(message);
  }, [onSubmit, message]);

  const disabledInputProps = {
    disabled: true,
    onChangeText: () => {},
  };

  return (
    <>
      <View style={[flex('flex-row'), mb(10)]}>
        <OETextInput
          label={labels.nameLabel}
          name="name"
          value={name}
          autoComplete="off"
          style={[mr(10), flex('flex-1')]}
          {...disabledInputProps}
        />
        <OETextInput
          label={labels.emailLabel}
          name="email"
          value={email}
          style={[flex('flex-1')]}
          autoComplete="off"
          {...disabledInputProps}
        />
      </View>
      <OETextInput
        placeholder={labels.messageInputPlaceholder}
        name="message"
        value={message}
        autoComplete="off"
        textContentType="none"
        onChangeText={handleFieldChange}
        multiline
        style={[height(300)]}
        maxLength={5000}
      />
      <FormFooter
        buttonSubmit={{
          onPress: handleSubmit,
          loading: isLoading,
          disabled: !message,
          label: labels.buttonSubmit,
          labelStyle: buttonTextColorConfirm
            ? color(buttonTextColorConfirm)
            : {},
        }}
        buttonCancel={{
          onPress: onCancel,
          label: labels.buttonCancel,
          style: buttonTextColorCancel
            ? borderColor(buttonTextColorCancel)
            : {},
          labelStyle: buttonTextColorCancel ? color(buttonTextColorCancel) : {},
        }}
        error={error}
      />
    </>
  );
};

export default ContactUsForm;
